import set from "@rill/set";
import { SettingsMenu } from "./SettingsMenu";

const SettingsMenuController = (app) => {
  app.get(
    "/settings-menu",
    set("heading", "Settings Menu"),
    async ({ res, locals }) => {
      res.body = <SettingsMenu locals={locals} />;
    }
  );
};

export default SettingsMenuController;
